var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.766037 7.00004H15.234C15.3346 6.99903 15.4343 7.01866 15.5271 7.0577C15.6198 7.09674 15.7035 7.15437 15.773 7.22704C15.8457 7.2966 15.9033 7.38032 15.9424 7.47302C15.9814 7.56573 16.001 7.66545 16 7.76604C16.001 7.86662 15.9814 7.96635 15.9424 8.05905C15.9033 8.15176 15.8457 8.23548 15.773 8.30504C15.7035 8.3777 15.6198 8.43533 15.5271 8.47437C15.4343 8.51342 15.3346 8.53304 15.234 8.53204H0.766037C0.66545 8.53304 0.565726 8.51342 0.473021 8.47437C0.380316 8.43533 0.296598 8.3777 0.227037 8.30504C0.154375 8.23548 0.0967429 8.15176 0.0577001 8.05905C0.0186574 7.96635 -0.000967765 7.86662 3.66983e-05 7.76604C-0.000967765 7.66545 0.0186574 7.56573 0.0577001 7.47302C0.0967429 7.38032 0.154375 7.2966 0.227037 7.22704C0.296598 7.15437 0.380316 7.09674 0.473021 7.0577C0.565726 7.01866 0.66545 6.99903 0.766037 7.00004Z",
    fill: "#004D9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.704be9ce12ca3bf2b831b995fc583f96.svg";
export { ForwardRef as ReactComponent };